import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { FiPlusCircle } from "react-icons/fi";
import { MdDone, MdOutlineFilter } from "react-icons/md";
import {
  RiDragMove2Fill,
  RiFolderSharedLine,
  RiMoreFill,
} from "react-icons/ri";
import { Button, Nav, Navbar } from "react-bootstrap";
import { useAppContext, useColorMatchContext } from "../../../context";
import {
  AddBottomSheet,
  ModalManager,
  ModalRenderer,
  MoreBottomSheet,
  SaveBottomSheet,
  useAddBtnModalState,
} from "../../index";
import style from "./MobileCommands.module.css";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { UpgradeToProModal } from "../../UpgradeToProModal";
import { FaStar } from "react-icons/fa";

const MobileCommands = ({ sortable, setSortable }) => {
  const { paletteId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const { colormatch } = useColorMatchContext();
  const { images, setCreateNewPaletteModal, user, state } = useAppContext();
  const { closeModal, modalState, showModal } = useAddBtnModalState();
  const [showBottomSheet, setShowBottomSheet] = useState({
    add: false,
    save: false,
    more: false,
  });
  const [category, setCategory] = useState("");
  const [show, setShow] = useState({
    save: false,
    download: false,
    share: false,
  });
  const [showProVersionModal, setShowProVersionModal] = useState(false);

  const userPro = user?.stripeSubscriptionStatus === "active" || user?.stripeSubscriptionStatus === "trialing";

  const handleOptionClick = (optionKey, optionLabel) => {
    if (optionKey !== "balloon" || optionKey !== "custom") {
      showModal(optionKey);
      setCategory(optionLabel);
    } else {
      showModal(optionKey);
    }
  };

  const handleShowBottomSheet = (option) => {
    setShowBottomSheet((prevState) => ({
      ...prevState,
      [option]: !prevState[option],
    }));
  };

  useEffect(() => {
    document.body.style.overflow = "auto";
  }, [modalState, show]);

  const handleCreateNewPalette = (e) => {
    const currentPath = location.pathname.split("/").slice(2).join("/"); // Obtener la ruta sin el prefijo de idioma
    const newPath = `/${i18n.language}/colormatch`;
    setShowBottomSheet({ more: false });

    if (currentPath !== "colormatch") {
      navigate(newPath);
    } else {
      setCreateNewPaletteModal(true);
    }
  };

  return (
    <>
      <Navbar fixed="bottom" className={style.mobileCommands}>
        <Nav justify className={style.navRow}>
          <Nav.Item>
            <Button
              onClick={handleCreateNewPalette}
              disabled={colormatch.length === 0 && state.images.length === 0}
              className={style.mobileCommandBtn}
            >
              <FiPlusCircle size="1.2rem" />
              {t("New")}
            </Button>
          </Nav.Item>
          <Nav.Item>
            <Button
              onClick={() => handleShowBottomSheet("add")}
              className={style.mobileCommandBtn}
            >
              <MdOutlineFilter size="1.2rem" />
              {t("Insert")}
            </Button>
          </Nav.Item>
          <Nav.Item>
            <Button
              onClick={() => setSortable(!sortable)}
              disabled={colormatch.length < 2}
              className={style.mobileCommandBtn}
            >
              {sortable ? (
                <MdDone size="1.5rem" />
              ) : (
                <RiDragMove2Fill size="1.5rem" />
              )}
              {sortable ? (
                <span>{t("Done")}</span>
              ) : (
                <span> {t("Reorder")}</span>
              )}
            </Button>
          </Nav.Item>
          <Nav.Item>
            <Button
              disabled={colormatch.length < 1}
              className={style.mobileCommandBtn}
              onClick={
                userPro
                  ? () =>
                      paletteId
                        ? handleShowBottomSheet("save")
                        : setShow({ save: true })
                  : () => setShowProVersionModal(true)
              }
            >
              <RiFolderSharedLine size="1.5rem" />
              {userPro ? (
                t("Save")
              ) : (
                <span className="d-flex align-items-center">
                  {t("Save")}
                  <FaStar color="#FF6563" className="ms-1" />
                </span>
              )}
            </Button>
          </Nav.Item>
          <Nav.Item>
            <Button
              className={style.mobileCommandBtn}
              onClick={() => handleShowBottomSheet("more")}
              disabled={colormatch.length < 1}
            >
              <RiMoreFill size="1.5rem" />
              {t("More")}
            </Button>
          </Nav.Item>
        </Nav>
      </Navbar>
      {/* ------------------------------------------------------------- */}
      <AddBottomSheet
        showBottomSheet={showBottomSheet.add}
        setShowBottomSheet={setShowBottomSheet}
        handleOptionClick={handleOptionClick}
      />
      <SaveBottomSheet
        showBottomSheet={showBottomSheet.save}
        setShowBottomSheet={setShowBottomSheet}
        setShow={setShow}
      />
      <MoreBottomSheet
        showBottomSheet={showBottomSheet.more}
        setShowBottomSheet={setShowBottomSheet}
        setShow={setShow}
        userProVersion={userPro}
        setShowProVersionModal={setShowProVersionModal}
      />
      {/* Add from library modals */}
      <ModalRenderer
        category={category}
        closeModal={closeModal}
        modalState={modalState}
      />
      {/* Save, Download and Share modals */}
      <ModalManager show={show} setShow={setShow} />

      {/* Upgrade to pro modal */}
      <UpgradeToProModal
        setShowProVersionModal={setShowProVersionModal}
        showProVersionModal={showProVersionModal}
      />
    </>
  );
};

export default MobileCommands;
